function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { capitalize } from '@applyboard/ui-utils';
import { chartColors } from "./colors";
import { renderToString } from 'react-dom/server';
import { ChartTooltip } from "./../../../components";
import { defaultChartOptions } from "./consts";
export var getChartColor = function getChartColor(color) {
  var thisColor = color.split('-')[0].toUpperCase();
  var thisColorIndex = Number(color.split('-')[1]);

  // checks if color exists, otherwise returns BLUE-12:
  thisColor = Object.keys(chartColors).includes(thisColor) ? thisColor : 'BLUE';
  if (!chartColors[thisColor][thisColorIndex]) {
    thisColor = 'BLUE';
    thisColorIndex = 12;
  }
  return chartColors[thisColor][thisColorIndex];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var checkIfSeriesDataIsOnCorrectFormat = function checkIfSeriesDataIsOnCorrectFormat(array) {
  var areAllElementsTypeOfNumber = array.every(function (element) {
    return typeof element === 'number';
  });
  return array.length > 0 && areAllElementsTypeOfNumber;
};
export var getChartFileName = function getChartFileName(chartTitle, chartSubtitle) {
  var chartExportFilename = '';
  var chartTitleArr = chartTitle.split(' ');
  for (var i in chartTitleArr) {
    chartExportFilename += capitalize(chartTitleArr[i]);
  }

  // subtitle?
  if (chartSubtitle) {
    var chartSubtitleArr = chartSubtitle.split(' ');
    chartExportFilename += '_';
    for (var _i in chartSubtitleArr) {
      chartExportFilename += capitalize(chartSubtitleArr[_i]);
    }
  }

  // current date
  chartExportFilename += "_".concat(new Date().toISOString().split('T')[0]);
  return chartExportFilename;
};
export var createChartOptions = function createChartOptions(_ref) {
  var _defaultChartOptions$, _defaultChartOptions$2;
  var _ref$chartDescription = _ref.chartDescription,
    chartDescription = _ref$chartDescription === void 0 ? undefined : _ref$chartDescription,
    chartHeight = _ref.chartHeight,
    chartLegendTrack = _ref.chartLegendTrack,
    chartPlotOptions = _ref.chartPlotOptions,
    _ref$chartSubtitle = _ref.chartSubtitle,
    chartSubtitle = _ref$chartSubtitle === void 0 ? undefined : _ref$chartSubtitle,
    chartTitle = _ref.chartTitle,
    chartTooltipDescription = _ref.chartTooltipDescription,
    chartXAxis = _ref.chartXAxis,
    _ref$extraDropdownOpt = _ref.extraDropdownOptions,
    extraDropdownOptions = _ref$extraDropdownOpt === void 0 ? {} : _ref$extraDropdownOpt,
    calculateTotalEarnings = _ref.calculateTotalEarnings;
  var chartOptions = _objectSpread(_objectSpread({}, defaultChartOptions), {}, {
    accessibility: {
      description: chartDescription
    },
    chart: _objectSpread(_objectSpread({}, defaultChartOptions.chart), {}, {
      height: chartHeight ? chartHeight + 60 : 360,
      // adding a few more px to account for legends
      marginTop: 80,
      events: {
        render: function render() {
          if (calculateTotalEarnings) calculateTotalEarnings(this.series);
        }
      }
    }),
    exporting: _objectSpread(_objectSpread({}, defaultChartOptions.exporting), {}, {
      enabled: false,
      chartOptions: _objectSpread(_objectSpread({}, (_defaultChartOptions$ = defaultChartOptions.exporting) === null || _defaultChartOptions$ === void 0 ? void 0 : _defaultChartOptions$.chartOptions), {}, {
        subtitle: {
          text: chartSubtitle ? chartSubtitle : undefined
        },
        title: {
          text: chartTitle
        }
      }),
      filename: getChartFileName(chartTitle, chartSubtitle),
      menuItemDefinitions: extraDropdownOptions
    }),
    plotOptions: _objectSpread(_objectSpread(_objectSpread({}, defaultChartOptions.plotOptions), chartPlotOptions), {}, {
      series: _objectSpread(_objectSpread({}, (_defaultChartOptions$2 = defaultChartOptions.plotOptions) === null || _defaultChartOptions$2 === void 0 ? void 0 : _defaultChartOptions$2.series), {}, {
        events: {
          legendItemClick: function legendItemClick() {
            if (chartLegendTrack) chartLegendTrack(this.name, this.visible);
          }
        }
      })
    }),
    tooltip: _objectSpread(_objectSpread(_objectSpread({}, defaultChartOptions.tooltip), chartTooltipDescription), {}, {
      formatter: function formatter() {
        if (chartTooltipDescription) {
          return renderToString(ChartTooltip(this, chartTooltipDescription(this)));
        } else {
          return renderToString(ChartTooltip(this));
        }
      }
    }),
    xAxis: _objectSpread(_objectSpread({}, defaultChartOptions.xAxis), chartXAxis)
  });
  return chartOptions;
};